function d4HideCart() {
  if(document.body.classList.contains('overflow-hidden')) {
    document.body.classList.remove('overflow-hidden');
    document.querySelector('.d4-cart-drawer-main').classList.remove('active');
  }
}


let d4LeftBtn = document.querySelector(".d4-addon-left-btn");
let d4Counter = 0;

function slider(counter) {
  const d4ProductSlider = document.querySelector(".d4-addon-product-wrapper");
  const d4Products = document.querySelectorAll(".d4-addon-product");

  // Check for wrapping logic for infinite scrolling
  if (counter < 0) {
    d4Counter = d4Products.length - 1; // Wrap to last product
  } else if (counter >= d4Products.length) {
    d4Counter = 0; // Wrap to first product
  }

  // Update slider position
  d4ProductSlider.style.transform = `translateX(-${d4Counter * 100}%)`;
}

function fnFD4SliderRightBtn() {
  d4Counter++;
  slider(d4Counter);
}

function fnFD4SliderLeftBtn() {
  d4Counter--;
  slider(d4Counter);
}

//Code for Add to cart Product
function addToCartD4(productId, quantityD5, btn) {
  // const travelatcD5 = document.querySelector(".d5-travel-pack-atc");
  if (btn) {
    btn.classList.add("d5-loader");
  }

  console.log("qty:", quantityD5);
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items: [
        {
          id: productId,
          quantity: quantityD5,
        },
      ],
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("test data", data);
      const addToCartButtonD4 = document.querySelector("#d4-addon-product-atc");
      d4RerenderTheCartSection();
      updateCartBubble();
      let intervalId = setInterval(() => {
        let cartTotal = document.querySelector(".docapp-right");
        if (cartTotal) {
          clearInterval(intervalId);
          intervalId = null;
          let totalAttribute = cartTotal.getAttribute("data-est-total");
          shippingBar(totalAttribute);
        }
      }, 100);

      setTimeout(() => {
        clearInterval(intervalId);
        intervalId = null;
        console.log("Element not found");
      }, 35000);
    })
    .catch((error) => {
      console.error("Error adding to cart:", error);
    })
    .finally(() => {
      if (btn) {
        btn.classList.remove("d5-loader");
      }
    });
}


async function d4RerenderTheCartSection(d4TrueLoading) {
  document.querySelector('.d4spinner').style.display = 'block';
  document.querySelector('.d4-cart-overlay').style.display = 'block';
  const parser = new DOMParser();
  console.log("reloading cart items");
  try {
    const response = await fetch("/?section_id=cart-drawer");
    const data = await response.text();
    const html = parser.parseFromString(data, "text/html");
    const newCartDrawerItems = html.querySelector("cart-drawer");
    const cartDrawerItems = document.querySelector("cart-drawer");

    if (newCartDrawerItems && cartDrawerItems) {
      // Update cart drawer with new items
      cartDrawerItems.innerHTML = newCartDrawerItems.innerHTML;
      const cartDrawer = document.querySelector("cart-drawer");

      if (cartDrawer) {
        const isCartEmpty = cartDrawerItems.querySelectorAll(".cart-item").length === 0;
        
        if (isCartEmpty) {
          cartDrawer.classList.add("is-empty");
           document.querySelector('.cart-drawer__overlay').addEventListener('click', ()=> {
             cartDrawer.classList.remove('active');
             document.body.classList.remove("overflow-hidden");
           });
             document.body.classList.remove("overflow-hidden");
        } else {
          cartDrawer.classList.add("active");
          document.body.classList.add("overflow-hidden");
          cartDrawer.classList.remove("is-empty");
        }
      }
    }
    document.querySelector('.d4spinner').style.display = 'none';
    document.querySelector('.d4-cart-overlay').style.display = 'none';

    console.log("Cart updated with the new function!");

    if (d4TrueLoading) {
      let intervalId = setInterval(() => {
        let cartTotal = document.querySelector(".docapp-est-total .geolizr-currency");
        if (cartTotal) {
          clearInterval(intervalId);
          intervalId = null;
          let totalAttribute = cartTotal.getAttribute("data-amount");
          shippingBar(totalAttribute);
        }
      }, 100);

      setTimeout(() => {
        clearInterval(intervalId);
        intervalId = null;
        console.log("Element not found");
      }, 35000);
    }

    d4Counter = 0;

    const judgeMeScript = document.getElementById("judgeMeScript");

    if (judgeMeScript) {
      judgeMeScript.remove();
      loadAndExec();
    } else {
      loadAndExec();
    }

    function loadAndExec() {
      const script = document.createElement("script");
      script.id = "judgeMeScript";
      script.src = "https://cdn.judge.me/loader.js";
      script.onload = function () {
        console.log("Script loaded and executed successfully!");
      };
      script.onerror = function () {
        console.error("Failed to load the script.");
      };
      document.body.appendChild(script);
    }
  } catch (error) {
    console.log(error);
  }
}


function onButtonClickD4(e) {
  e.preventDefault();
  console.log("This button is being clicked");
  const btn = e.target;
  setTimeout(() => {
    let cartTotal = document
      .querySelector(".docapp-est-total .geolizr-currency")
      .getAttribute("data-amount");
    shippingBar(cartTotal);
  }, 5000);
  console.log(document.querySelector(".docapp-est-total .geolizr-currency"));
  const productId = btn.getAttribute("data-product-id");
  addToCartD4(productId);
}
function onButtonClickD5(e) {
  e.preventDefault();
  console.log("This button is being clicked");
  const btn = e.target; 
  setTimeout(() => {
    let cartTotal = document
      .querySelector(".docapp-est-total .geolizr-currency")
      .getAttribute("data-amount");
    shippingBar(cartTotal);
  }, 5000);
  console.log(document.querySelector(".docapp-est-total .geolizr-currency"));
  const productId = btn.getAttribute("data-product-id");
  const quantityInput = document.querySelector('.quantity-input-d5');
  const quantityD5 = btn.getAttribute('data-quantity') ? parseInt(btn.getAttribute('data-quantity'), 10) : 1;
  addToCartD4(productId, quantityD5, btn);
} 
// Function to update the data-product-id when a variant is selected
function updateProductId(dropdown, productId) {
  const selectedVariantId = dropdown.value;
  const radioButtons = document.querySelectorAll(`input[name="variant-${productId}"]`);
  radioButtons.forEach((radio) => {
    if (radio === dropdown) {
      radio.classList.add('d4-active-variant');
    } else {
      radio.classList.remove('d4-active-variant');
    }
  });
  const addToCartButton = document.getElementById(`d4-addon-product-atc-${productId}`);
  if (addToCartButton) {
    addToCartButton.setAttribute("data-product-id", selectedVariantId);
    console.log(`Updated data-product-id for product ${productId} to: ${selectedVariantId}`);
  } else {
    console.warn(`Add to Cart button not found for product ${productId}`);
  }
}
function onButtonClickNewD4(e) {
  e.preventDefault();
  console.log("This button is being clicked");

  const btn = e.target;
  const productId = btn.getAttribute("data-product-id");

  if (!productId) {
    alert("Please select a product variant.");
    return;
  }
  addToCartD4(productId);

  setTimeout(() => {
    const cartTotalElement = document.querySelector(".docapp-est-total .geolizr-currency");
    if (cartTotalElement) {
      const cartTotal = cartTotalElement.getAttribute("data-amount");
      shippingBar(cartTotal);
    } else {
      console.warn("Cart total element not found.");
    }
  }, 5000);
}



//Shipping bar JS
let intervalId = setInterval(() => {
  let cartTotal = document.querySelector(".docapp-est-total .geolizr-currency");
  if (cartTotal) {
    clearInterval(intervalId);
    intervalId = null;
    let totalAttribute = cartTotal.getAttribute("data-amount");
    shippingBar(totalAttribute);
  }
}, 100);

setTimeout(() => {
  clearInterval(intervalId);
  intervalId = null;
  console.log("Element not found");
}, 35000);

function shippingBar(dataAmount) {
  let observerInitialized = false;

const checkAndInitializeObserver = () => {
    const targetDiv = document.querySelector('.docapp-cart-with-coupon-summary');
    if (targetDiv && !observerInitialized) {
        initializeCartObserver();
        observerInitialized = true;
    } else if (!targetDiv) {
        observerInitialized = false; // Reset if the cart is removed
    }
};

// Check every 500ms for the target div
setInterval(checkAndInitializeObserver, 500);
    const isShippingLoaded = localStorage.getItem('isShippingLoaded')
    let shippingText = document.querySelector(".d4-free-shipping-text-main");
    const barCompleted = document.querySelector(".d4-bar-completed");
  let freeShipping = document.querySelector('.d4-shipping-icon');
  let freePack = document.querySelector('.d4-travel-icon');
    let firstMilestone = 95;
    let secondMilestone = 225;

    dataAmount = Number(dataAmount);

    if (isNaN(dataAmount)) {
        console.error("Error: dataAmount is not a valid number");
        return;
    }

    const percentage = Math.min((dataAmount / secondMilestone) * 100, 100);
    console.log(`Calculated percentage: ${percentage}%`);

    if (barCompleted) {
        barCompleted.style.width = `${percentage}%`;
        console.log(`Shipping bar width set to ${percentage}%`);
    } else {
        console.error("Error: .d4-bar-completed element not found");
    }

    if (dataAmount < firstMilestone) {
       freeShipping.classList.add('first');
      freeShipping.classList.remove('second');
        localStorage.setItem('isShippingLoaded', false)
        let remaining = firstMilestone - dataAmount;
        shippingText.innerHTML = `You are <span>$${remaining.toFixed(
            2
        )}</span> away from <span>Free Shipping!</span>`;
    
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: "50659076407599", // replace with the correct line item ID
      quantity: 0
    })
  })
    .then(response => response.json())
    .then(data => {
      if (data.items) {
        console.log("Item removed successfully", data);
        d4RerenderTheCartSection();
        updateCartBubble();
      } else {
        console.log("Failed to remove item", data);
      }
    })
    .catch(err => console.error("Error removing item from cart:", err));


      fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: "50777790873903", // replace with the correct line item ID
      quantity: 0
    })
  })
    .then(response => response.json())
    .then(data => {
      if (data.items) {
        console.log("Item removed successfully", data);
        d4RerenderTheCartSection();
        updateBtnShipping();
        updateCartBubble();
      } else {
        console.log("Failed to remove item", data);
      }
    })
    .catch(err => console.error("Error removing item from cart:", err));


      
    } else if (dataAmount >= firstMilestone && dataAmount < secondMilestone) {
      freePack.classList.remove('second');
      freePack.classList.add('first');
      freeShipping.classList.remove('first');
      freeShipping.classList.add('second');
        localStorage.setItem('isShippingLoaded', false)
        let remaining = secondMilestone - dataAmount;
        shippingText.innerHTML = `You are <span>$${remaining.toFixed(
            2
        )}</span> away from a <span>Free Travel Pack!</span>`;
      
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: "50659076407599", // replace with the correct line item ID
      quantity: 0
    })
  })
    .then(response => response.json())
    .then(data => {
      if (data.items) {
        console.log("Item removed successfully", data);
        d4RerenderTheCartSection();
        updateBtnShipping();
        updateCartBubble();
      } else {
        console.log("Failed to remove item", data);
      }
    })
    .catch(err => console.error("Error removing item from cart:", err));


      fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: "50777790873903", // replace with the correct line item ID
      quantity: 0
    })
  })
    .then(response => response.json())
    .then(data => {
      if (data.items) {
        console.log("Item removed successfully", data);
        d4RerenderTheCartSection();
        updateBtnShipping();
        updateCartBubble();
      } else {
        console.log("Failed to remove item", data);
      }
    })
    .catch(err => console.error("Error removing item from cart:", err));


    } else {
      freeShipping.classList.remove('first');
      freeShipping.classList.add('second');
      freePack.classList.add('second');
      freePack.classList.remove('first');
        shippingText.innerHTML = `<span>Free Shipping</span> & <span>Free Travel Pack</span> unlocked!`;
        (async () => {
            const body = JSON.stringify({ items: [{ id: 50659076407599, quantity: 1 }] })
            try {
                if (isShippingLoaded == false  || isShippingLoaded == undefined || isShippingLoaded == "false") {
                  console.log("adding product to cart")
                    const response = await fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: body,
                    });
                  console.log(response)
                    const data = await response.json();
                  console.log("added product to cart")
                  const testTrue = true;
                    d4RerenderTheCartSection(testTrue);
                  console.log('section re rendered');
                    localStorage.setItem('isShippingLoaded', true)
                } else {
                  console.log("it's already loaded")
                }
            } catch (error) {
                console.log(error)
            }
        })();

      (async () => {
            const body = JSON.stringify({ items: [{ id: 50777790873903, quantity: 1 }] })
            try {
                if (isShippingLoaded == false  || isShippingLoaded == undefined || isShippingLoaded == "false") {
                  console.log("adding product to cart")
                    const response = await fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: body,
                    });
                  console.log(response)
                    const data = await response.json();
                  console.log("added product to cart")
                  const testTrue = true;
                    d4RerenderTheCartSection(testTrue);
                  console.log('section re rendered');
                    localStorage.setItem('isShippingLoaded', true)
                } else {
                  console.log("it's already loaded")
                }
            } catch (error) {
                console.log(error)
            }
        })();
    }
}


 function updateCartBubble() {
  fetch('/?section_id=cart-icon-bubble')
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newBubble = doc.querySelector('.cart-count-bubble');
      
      const currentBubble = document.querySelector('.cart-count-bubble');
      if (currentBubble && newBubble) {
        currentBubble.replaceWith(newBubble);
      }
    })
    .catch(error => {
      console.error('Error fetching cart bubble section:', error);
    });
}

function updateBtnShipping() {
  console.log('function runs');
  // Show the loading spinner at the start of the function
  document.querySelector('.d4spinner').style.display = 'block';
  document.querySelector('.d4-cart-overlay').style.display = 'block';
  setTimeout(() => {
    let cartTotal = document.querySelector(".docapp-est-total .geolizr-currency");
    if (cartTotal) {
      let totalAttribute = cartTotal.getAttribute("data-amount");
      shippingBar(totalAttribute);
    }

    const judgeMeScript = document.getElementById("judgeMeScript");

    if (judgeMeScript) {
      judgeMeScript.remove();
      loadAndExec();
    } else {
      loadAndExec();
    }

    function loadAndExec() {
      const script = document.createElement("script");
      script.id = "judgeMeScript";
      script.src = "https://cdn.judge.me/loader.js";
      script.onload = function () {
        console.log("Script loaded and executed successfully!");
      };
      script.onerror = function () {
        console.error("Failed to load the script.");
      };
      document.body.appendChild(script);
    }

    d4Counter = 0;
    console.log('Function processing');
     document.querySelector('.d4spinner').style.display = 'none';
    document.querySelector('.d4-cart-overlay').style.display = 'none';
    document.querySelector('#CartDrawer-Overlay').addEventListener('click', ()=> {
  if(document.body.classList.contains('overflow-hidden')) {
    document.body.classList.remove('overflow-hidden');
    document.querySelector('.d4-cart-drawer-main').classList.remove('active');
  }
})
  }, 5000);
  document.querySelector('#CartDrawer-Overlay').addEventListener('click', ()=> {
  if(document.body.classList.contains('overflow-hidden')) {
    document.body.classList.remove('overflow-hidden');
    document.querySelector('.d4-cart-drawer-main').classList.remove('active');
  }
});
  setTimeout(() => {
    if (document.querySelector('.d4spinner').style.display !== 'none') {
      document.querySelector('.d4spinner').style.display = 'none';
    }
    if (document.querySelector('.d4-cart-overlay').style.display !== 'none') {
      document.querySelector('.d4-cart-overlay').style.display = 'none';
    }
  }, 5100);
  console.log('function ends');
}

function initializeCartObserver() {
    // Select the target element
    const targetDiv = document.querySelector('.docapp-cart-with-coupon-summary');

    if (targetDiv) {
        // Create a MutationObserver callback
        const observerCallback = (mutationsList, observer) => {
            for (const mutation of mutationsList) {
                // Check for any type of change (childList, attributes, or text content)
                if (
                    mutation.type === 'childList' ||
                    mutation.type === 'characterData' ||
                    mutation.type === 'attributes'
                ) {
                    updateBtnShipping(); // Call the already defined function
                    break; // Run once per mutation batch
                }
            }
        };

        // Create an observer instance
        const observer = new MutationObserver(observerCallback);

        // Configuration object to specify what to observe
        const observerConfig = {
            childList: true,       // Detect addition/removal of child elements
            attributes: true,      // Detect changes to attributes
            characterData: true,   // Detect text content changes
            subtree: true,         // Observe all descendants
        };

        // Start observing the target div
        observer.observe(targetDiv, observerConfig);
        console.log('MutationObserver started on the target div.');
    } else {
        console.log('Target div not found. MutationObserver not started.');
    }
}

let observerInitialized = false;

const checkAndInitializeObserver = () => {
    const targetDiv = document.querySelector('.docapp-cart-with-coupon-summary');
    if (targetDiv && !observerInitialized) {
        initializeCartObserver();
        observerInitialized = true;
    } else if (!targetDiv) {
        observerInitialized = false; // Reset if the cart is removed
    }
};

// Check every 500ms for the target div
setInterval(checkAndInitializeObserver, 500);



// window.reloadCartDrawerItems = reloadCartDrawerItems;
window.shippingBar = shippingBar;
window.onButtonClickD5 = onButtonClickD5;